import { useState, useEffect } from "react";
import { showToast } from "../../Buttons/Toaster";
import "../../../components/CSSCustom/toaster.css";
import Form from "react-bootstrap/Form";
import "../../CSSCustom/adduser.css";
import CustomTooltip from "../../Buttons/CustomTooltip";

const EditUser = ({ user, onCancel = () => {}, onSave = () => {} }) => {
  const [formData, setFormData] = useState({
    role: "",
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    email: "",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    email: "",
    role: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const roleOptions = [
    { id: "user", name: "user" },
    { id: "admin", name: "admin" },
    // { id: 'power-iser', name: 'power-user' },
    // { id: 'manager', name: 'manager' }
  ].sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    if (user) {
      const nameParts = user.full_name ? user.full_name.split(" ") : ["", ""];
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      setFormData({
        role: user.role || "User",
        firstName: firstName,
        lastName: lastName,
        username: user.username || "",
        password: "********",
        email: user.email || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    if (!formData.role || formData.role.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        role: "Role is required",
      }));
      return false;
    }

    let isValid = true;
    const newErrors = {
      firstName: "",
      lastName: "",
      username: "",
      password: "",
      email: "",
      role: "",
    };

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      isValid = false;
    } else if (!/^[a-zA-Z0-9 ]+$/.test(formData.firstName)) {
      newErrors.firstName = "Only letters, numbers and spaces allowed";
      isValid = false;
    } else if (
      formData.firstName.length < 3 ||
      formData.firstName.length > 100
    ) {
      newErrors.firstName = "First name must be between 3-100 characters";
      isValid = false;
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
      isValid = false;
    } else if (!/^[a-zA-Z0-9 ]+$/.test(formData.lastName)) {
      newErrors.lastName = "Only letters, numbers and spaces allowed";
      isValid = false;
    } else if (formData.lastName.length < 1) {
      newErrors.lastName = "Last name must contain atleast one character";
      isValid = false;
    }

    if (!formData.username.trim()) {
      newErrors.username = "Username is required";
      isValid = false;
    } else if (!/^[a-zA-Z0-9_]+$/.test(formData.username)) {
      newErrors.username = "Only letters, numbers and underscores allowed";
      isValid = false;
    } else if (formData.username.length < 3 || formData.username.length > 50) {
      newErrors.username = "Username must be between 3-50 characters";
      isValid = false;
    }

    if (
      formData.password &&
      formData.password !== "********" &&
      !(formData.password.length >= 8 && formData.password.length <= 50)
    ) {
      newErrors.password = "Password must be 8-50 characters";
      isValid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
      isValid = false;
    } else if (formData.email.length > 100) {
      newErrors.email = "Email must be less than 100 characters";
      isValid = false;
    }

    if (!formData.role) {
      newErrors.role = "Role is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
      return;
    }

    // Check if any fields have actually changed
    const nameParts = user.full_name ? user.full_name.split(" ") : ["", ""];
    const originalFirstName = nameParts[0] || "";
    const originalLastName = nameParts.slice(1).join(" ") || "";
    const hasChanges =
      formData.firstName !== originalFirstName ||
      formData.lastName !== originalLastName ||
      formData.username !== user.username ||
      formData.email !== user.email ||
      formData.role !== user.role ||
      (formData.password && formData.password !== "********");

    if (!hasChanges) {
      showToast("No changes were made", "success"); // Using "info" type instead of "success"
      onCancel(); // This will close the edit user screen
      return;
    }
    setIsSubmitting(true);
const apiEndUpdate = process.env.REACT_APP_API_URL_CODE_CONVERSION;

    try {
      const access_token = sessionStorage.getItem("access_token");

      if (!access_token) {
        throw new Error("No access token found");
      }

      const params = new URLSearchParams();
      params.append("user_id_to_edit", user.user_id.toString());

      if (formData.firstName !== user.full_name.split(" ")[0]) {
        params.append("first_name", formData.firstName);
      }

      if (formData.lastName !== user.full_name.split(" ").slice(1).join(" ")) {
        params.append("last_name", formData.lastName);
      }

      if (formData.username !== user.username) {
        params.append("username", formData.username);
      }

      if (formData.email !== user.email) {
        params.append("email", formData.email);
      }

      if (formData.role !== user.role) {
        // Changed from 'role' to 'role_name' to match backend expectation
        params.append("role_name", formData.role);
      }

      if (formData.password && formData.password !== "********") {
        params.append("new_password", formData.password);
      }

      const response = await fetch(
        `${apiEndUpdate}/edit_user?${params.toString()}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${access_token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 401) {
        throw new Error("Session expired. Please login again.");
      }

      const data = await response.json();

      if (response.ok && data.message === "User details updated successfully") {
        showToast(data.message, "success");
        onSave();
      } else {
        throw new Error(data.message || "Failed to update user");
      }
    } catch (error) {
      showToast(error.message || "Failed to update user details", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="right-bar3 p-3" style={{ width: "auto" }}>
      <div>
        <div className="d-flex align-items-center justify-content-between">
          <h6 className="font-size-13 mb-0 fw-medium text-dark">Edit User</h6>
          <CustomTooltip
            content="Close"
            placement="left"
            fallbackPlacements={["bottom"]}
          >
            <i
              onClick={onCancel}
              className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
            />
          </CustomTooltip>
        </div>
         <div className="trace-label  mt-1 pe-3 d-flex align-items-center mb-3 w-fit-content">
          <img
           src="/assets/images/trace_label.png"
            className="w-14px me-2"
            alt="Job icon"
          />
          <h6 className="font-size-10 mb-0 text-dark"> Update User Details as needed</h6>
        </div>
        <div className="mt-3">
          <label className="label-text"
            style={{
              display: "block",
              fontSize: "12px",
              fontWeight: "bold",
              marginBottom: "5px",
            }}
          >
            Select Role
          </label>
          <select
            name="role"
            className="form-select bordercolourcustom"
            value={formData.role}
            onChange={handleChange}
            
            style={{
              borderRadius: "4px",
              padding: "8px 12px",
              fontSize: "12px",
              width: "100%",
              appearance: "none",
              backgroundImage:
                "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 8px center",
              backgroundSize: "12px",
            }}
          >
            <option value="user">user</option>
            <option value="admin">admin</option>
            {/* <option value="power-user">Power-User</option>
            <option value="manager">Manager</option> */}
          </select>

          <h6 className="fw-sbold font-size-12 mt-3 ">
            First Name <span style={{ color: "red" }}>*</span>
          </h6>
          <input
            type="text"
            className={`form-control highlighted-input font-size-12 doc-search mt-2 colorfor-placeholder styled-input ${
              errors.firstName ? "is-invalid" : ""
            }`}
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Enter first name"
          />
          {errors.firstName && (
            <div className="text-danger font-size-10">{errors.firstName}</div>
          )}

          <h6 className="fw-sbold font-size-12 mt-3">
            Last Name <span style={{ color: "red" }}>*</span>
          </h6>
          <input
            type="text"
            className={`form-control highlighted-input font-size-12 doc-search mt-2 colorfor-placeholder styled-input ${
              errors.lastName ? "is-invalid" : ""
            }`}
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Enter last name"
          />
          {errors.lastName && (
            <div className="text-danger font-size-10">{errors.lastName}</div>
          )}

          <h6 className="fw-sbold font-size-12 mt-3">
            Username <span style={{ color: "red" }}>*</span>
          </h6>
          <input
            type="text"
            className={`form-control highlighted-input font-size-12 doc-search mt-2 colorfor-placeholder styled-input ${
              errors.username ? "is-invalid" : ""
            }`}
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Enter username"
          />
          {errors.username && (
            <div className="text-danger font-size-10">{errors.username}</div>
          )}

          <h6 className="fw-sbold font-size-12 mt-3">Password</h6>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"} // Fixed: Now properly toggles between text and password types
              className={`form-control highlighted-input font-size-12 doc-search mt-2 colorfor-placeholder styled-input ${
                errors.password ? "is-invalid" : ""
              }`}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Leave blank to keep current password"
            />
            {/* <button
    type="button"
    style={{height:"38px", marginTop:"7px"}}
    className="btn btn-outline-secondary"
    onClick={() => setShowPassword(!showPassword)}
  >
    <i className={`mdi ${showPassword ? "mdi-eye-off" : "mdi-eye"}`}></i>
  </button> */}
          </div>
          {errors.password && (
            <div className="text-danger font-size-10">{errors.password}</div>
          )}

          <h6 className="fw-sbold font-size-12 mt-3">
            Email <span style={{ color: "red" }}>*</span>
          </h6>
          <input
            type="text"
            className={`form-control highlighted-input font-size-12 doc-search mt-2 colorfor-placeholder styled-input ${
              errors.email ? "is-invalid" : ""
            }`}
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter email"
          />
          {errors.email && (
            <div className="text-danger font-size-10">{errors.email}</div>
          )}

          <div className="button-container mt-3">
            <button
              type="button"
              onClick={onCancel}
              className="btn btn-closebtn custom-button"
              style={{ marginRight: "10px" }}
              disabled={isSubmitting}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary custom-button"
              onClick={handleUpdate}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
